export const aggOptions = ['min', 'max', 'count', 'sum', 'avg'];

export const aggIntl = {
  min: 'dashboards.chart.min',
  max: 'dashboards.chart.max',
  count: 'dashboards.chart.count',
  sum: 'dashboards.chart.sum',
  avg: 'dashboards.chart.avg',
};

export const aggregationFactory = (aggregations, colors, chartTypes) => {
  const response = {};
  Object.entries(aggregations).forEach(([key, objectValue]) => {
    response[key] = {
      ...objectValue,
      color: colors[key],
      displayType: chartTypes[key],
    };
  });
  return response;
};

export const DEFAULT_CHART_TYPE = 'bar';
